// import toastr from '../../../../../bower_components/toastr/toastr';
import toastr from 'toastr/build/toastr.min';
import * as jcf from 'jcf/dist/js/jcf';
import $ from 'jquery';
import { setToastr } from './toastr';
import { executeValidator } from './bootstrap-validator-included';
import { registerEvent } from './mon-compte-log';
import { parseFormToJson } from './form-helper';
import Funding from './funding';
import { facebookEventQuotationGenerated } from './facebookEvents';
import RepurchaseForm from './repurchase-form';

var isCommand = false;
function getDataForCreateQuotation() {
    // DÉCLARATION DES VARIABLES
    const $btnDevis = $('#boutonDevis');
    const $colorExterior = $('.chkOutsideColorChoice');
    const $colorInterior = $('.chkInsideColorChoice');
    const $chosenFundingPropositionBtn = $('.chosenFundingProposition');

    const idCar = $btnDevis.data('idcar');
    const options = [];
    const accessories = [];
    const service = [];
    const exteriorColor = [];
    const interiorColor = [];
    let extensionGarantie;
    const fundingPropositions = [];
    const chosenFundingPropositionId = $('.chosenFundingProposition:checked').attr('id');
    const $administrativeCosts = $('#administrativeCosts');
    let administrativeCosts = 0;
    if ($administrativeCosts.length === 1 && $administrativeCosts.is(':checked')) {
        administrativeCosts = $administrativeCosts.data('price');
    }

    const returnObject = {};

    // RÉCUPÉRATION DES DONNÉES
    $('.chkOptionnalOption').each((index, element) => {
        const $element = $(element);
        options.push({ id: $element.val(), value: $element.prop('checked') });
    });

    $('.chkOptionnalAccessory').each((index, element) => {
        const $element = $(element);
        if (!accessories.find(a => a.id === $element.val())) {
            accessories.push({ id: $element.val(), value: $element.prop('checked') });
        }
    });

    $('.services').each((index, element) => {
        const $element = $(element);
        service.push({ id: $element.val(), value: $element.prop('checked') });
    });

    extensionGarantie = $('input[name=extensionGarantie]:checked').val();

    if ($colorExterior.length > 0) {
        $colorExterior.each((index, element) => {
            const $element = $(element);

            if ($element.prop('checked') === true) {
                exteriorColor.push({ id: $element.val(), value: $element.prop('checked') });
            }
        });
    }

    if ($colorInterior.length > 0) {
        $colorInterior.each((index, element) => {
            const $element = $(element);

            if ($element.prop('checked') === true) {
                interiorColor.push({ id: $element.val(), value: $element.prop('checked') });
            }
        });
    }

    $chosenFundingPropositionBtn.each((index, element) => {
        const $element = $(element);

        if ($element.attr('id') !== 'none') {
            const fundingType = $element.attr('data-type');
            const fundingOrganization = $element.attr('data-fundingOrganization');
            const proposition = Funding.getFundingRequestData(fundingType, fundingOrganization);
            proposition.selected = $element.attr('id') === chosenFundingPropositionId;
            fundingPropositions.push(proposition);
        }
    });

    // PRÉPARATION DES DONNÉES À ENVOYER
    if ($colorExterior.length > 0 && exteriorColor.length === 0) {
        returnObject.error = 'Veuillez sélectionner une couleur extérieure.';
    } else {
        // PRÉPARATION DES DONNÉES À ENVOYER
        if ($colorInterior.length > 0 && interiorColor.length === 0) {
            returnObject.error = 'Veuillez sélectionner une couleur intérieure.';
        } else {
            returnObject.id = idCar;
            returnObject.administrativeCosts = administrativeCosts;

            if (options.length > 0) {
                returnObject.options = options;
            }

            if (exteriorColor.length > 0) {
                returnObject.exteriorColor = exteriorColor;
            }

            if (interiorColor.length > 0) {
                returnObject.interiorColor = interiorColor;
            }

            if (accessories.length > 0) {
                returnObject.accessories = accessories;
            }

            if (service.length > 0) {
                returnObject.service = service;
            }

            if (fundingPropositions.length > 0) {
                returnObject.fundingPropositions = fundingPropositions;
            }

            if (typeof extensionGarantie !== 'undefined' && extensionGarantie.length > 0) {
                returnObject.extensionGarantie = extensionGarantie;
            }
        }
    }

    return returnObject;
}

function isExpedicar() {
    return $('#withExpedicarQuotation').is(':checked');
}

function getCompleteDataForCreateQuotation() {
    let dataForQuotation = getDataForCreateQuotation();

    if (typeof dataForQuotation.error !== 'undefined') {
        dataForQuotation = false;
    } else {
        const withReprise = $('input[name=with_reprise]').prop('checked');

        /* With E-motors */
        if ($('#withEmotorsQuotation').is(':checked')) {
            dataForQuotation.deliveryMethod = 'emotors';
            dataForQuotation.deliveryPoint = $('#selectDeliveryPointEmotorsQuotation').val();

        /* With Expedicar */
        } else if (isExpedicar()) {
            const expedicarServices = [];
            if ($('#expedicarWithHandoverServiceQuotation').is(':checked')) {
                expedicarServices.push($('#expedicarWithHandoverServiceQuotation').val());
            }
            if ($('#expedicarWithExteriorWashingQuotation').is(':checked')) {
                expedicarServices.push($('#expedicarWithExteriorWashingQuotation').val());
            }

            dataForQuotation.deliveryMethod = 'expedicar';
            dataForQuotation.deliveryPoint = 0;
            dataForQuotation.expedicarAddress = $('#deliveryAddressExpedicarQuotation').val();
            dataForQuotation.expedicarZipCode = $('#deliveryZipCodeExpedicarQuotation').val();
            dataForQuotation.expedicarCity = $('#deliveryCityExpedicarQuotation').val();
            dataForQuotation.expedicarCountry = $('#deliveryCountryExpedicarQuotation').val();
            dataForQuotation.expedicarServices = expedicarServices;

        /* With Carrier */
        } else {
            dataForQuotation.deliveryMethod = 'emotors';
            dataForQuotation.deliveryPoint = $('#selectDeliveryPointCarrierQuotation').val();

            if (!dataForQuotation.deliveryPoint) {
                dataForQuotation.deliveryPoint = $('#selectDeliveryPointQuotation').val();
            }
        }

        if (typeof withReprise !== 'undefined') {
            dataForQuotation.withReprise = withReprise;
        }
    }

    return dataForQuotation;
}

function setPostalQuotation(postalQuotationModalContent, toastr) {
    const $choosePostalQuotationAddress = $('#choosePostalQuotationAddress');

    $choosePostalQuotationAddress.html(postalQuotationModalContent);
    jcf.replaceAll($choosePostalQuotationAddress);

    // Ajout d'adresse
    $('#addAddressFormContainerButton').click(() => {
        $('#addAddressFormContainerButtonContainer, #addressesListForPostalQuotation').hide();
        $('#addAddressFormContainer').removeClass('hide');

        // Bug position modal
        $choosePostalQuotationAddress.modal('show');
    });

    // Enregistrement de la demande de devis par voie postale
    $('#savePostalQuotationAddress').click(function (event) {
        const $postalQuotationAddressRadio = $('input[type="radio"][name="postalQuotationAddress"]');

        // On vérifie si les boutons radio on l'attribut data-checked à true
        // Si c'est le cas on mets à jour la propriété checked pour qu'elle corresponde à l'html
        let i = 0;
        let $radioButton = '';
        let isChecked = false;
        for (i; i < $postalQuotationAddressRadio.length; i++) {
            $radioButton = $($postalQuotationAddressRadio[i]);
            isChecked = $radioButton.attr('data-checked');
            if (isChecked === 'true') {
                $radioButton.prop('checked', true);
            }
        }

        const $savePostalQuotationAddress = $(event.currentTarget);
        const $postalQuotationAddressRadioChecked = $('input[type="radio"][name="postalQuotationAddress"]:checked');
        const $addAddressFormContainer = $('#addAddressFormContainer');
        const errorMessage = 'Oops, une erreur est survenue, veuillez réessayer dans quelques instants';
        let formData = {};

        if ($postalQuotationAddressRadioChecked.length === 0) {
            // Validation du formulaire d'ajout d'adresse
            $addAddressFormContainer.validator('validate');

            if ($addAddressFormContainer.find('.has-error').length > 0) {
                // On a pas choisi d'adresse, on affiche une erreur
                setToastr(toastr, 'Vous devez choisir ou renseigner une nouvelle adresse pour valider votre demande', 'error');
                return false;
            }

            formData = parseFormToJson($addAddressFormContainer);
        } else {
            // Ajout de l'addressId aux data envoyées
            formData.addressId = $postalQuotationAddressRadio.val();
        }

        // Ajout du carId aux data envoyées
        formData.quotationId = $savePostalQuotationAddress.attr('data-quotation-id');

        $('.modal').modal('hide');

        $.ajax({
            url: $savePostalQuotationAddress.attr('data-path'),
            method: 'POST',
            dataType: 'json',
            data: formData,
        }).done((data) => {
            if (data === true) {
                setToastr(toastr, 'Votre demande de devis par voie postale a été prise en compte !', 'success');
            } else {
                setToastr(toastr, errorMessage, 'error');
            }
        }).fail(() => {
            setToastr(toastr, errorMessage, 'error');
        });
    });
}

function createQuotation(url, jsonData, toastr, isCommand) {
    const $quotationDynamiqueModal = $('#quotation-dynamique-modal');
    const $quotationBaseModal = $('#quotation-base-modal');

    const $modalTunneldDevis = $('#modalTunnelDevis');
    const $modalTunnelDevisDynamique = $('#modalTunnelDevisDynamique');
    let $modalFormulaireConnexion;
    let $modalFormulaireInscription;
    let callBackRegister;
    let modalNumber;
    let modalId;
    let modalContent;
    let $apeCode;

    $.ajax({
        url,
        method: 'POST',
        dataType: 'json',
        data: jsonData,
    }).done(function (rep) {
        if (isCommand && ('redirectcommand' in rep)) {
            window.location.href = rep.redirectcommand;
            return;
        }

        $('.loaderPDF').addClass('hide');
        $quotationDynamiqueModal.show();
        $quotationBaseModal.hide();
        $('.tunnelDevisStep2, .headerTunnelDevisStep2, .footerTunnelDevisStep2').fadeOut(function () {
            $('.tunnelDevisStep3, .headerTunnelDevisStep3, .footerTunnelDevisStep3').fadeIn();
        });
        $('.nextStepTunnelDevisStep2').show();

        switch (rep.type) {
        case 'not-connected':
            $('#quotation-dynamique-modal').html(rep.html);
            $modalFormulaireConnexion = $('#modalFormulaireConnexion');
            $modalFormulaireInscription = $('#modalFormulaireInscription');

            callBackRegister = function () {
                $modalTunneldDevis.modal('hide');
                createQuotation(url, jsonData, toastr, isCommand);
            };

            $modalFormulaireConnexion.hide();
            $modalTunneldDevis.modal('hide');
            $apeCode = $('.apeCode');
            $apeCode.parent().hide();
            $apeCode.val('').removeAttr('minlength').prop('required', false).attr('data-validate', false)
                .validator('update')
                .parent()
                .hide();

            executeValidator();
            registerEvent($modalFormulaireInscription, callBackRegister);

            $modalTunnelDevisDynamique.modal();
            jcf.replaceAll();
            $('[rel="tooltip"]').tooltip();
            break;

        case 'success-creation-quotation':
            facebookEventQuotationGenerated();
            $modalTunneldDevis.modal('hide');
            $modalTunnelDevisDynamique.modal('hide');

            modalNumber = $('.generatedModal').length;
            modalId = `modal-document${modalNumber}`;
            modalContent = rep.html;

            modalContent = `<div class="modal fade in generatedModal" id="${modalId}" role="document">
                <div class = "modal-dialog  modal-lg" role = "document">
                    <div class = "modal-content">
                        ${modalContent}
                    </div>
                </div>
            </div>`;

            $('body').append(modalContent);

            if ($('input[name="with_reprise"]').is(':checked')) {
                $('.btn-reprise').show();
            } else {
                $('.btn-reprise').hide();
            }

            jcf.replaceAll();

            if (typeof rep.postalQuotationModalContent !== 'undefined' && rep.postalQuotationModalContent.length > 0) {
                setPostalQuotation(rep.postalQuotationModalContent, toastr);
            }
            // TODO  GOWSAN voir pour centrer le modal
            $(`#${modalId}`).modal('show');
            break;
        }
    }).fail(() => {
        $('.nextStepTunnelDevisStep2').show();
        $('.loaderPDF').addClass('hide');
        setToastr(toastr, 'Oops, une erreur est survenue, veuillez réessayer dans quelques instants', 'error');
    });
}

$('#selectDeliveryPointEmotors, #selectDeliveryPointCarrier').change((event) => {
    const customFormInstance = jcf.getInstance($(event.currentTarget));
    customFormInstance.refresh();
});

$('#boutonDevis, #boutonCommande').click(function (event) {
    const createQutotationAjaxURL = $(event.currentTarget).data('path-create-quotation');
    let dataForQuotation = [];
    const $modalTunnelDevis = $('#modalTunnelDevis');

    const isPro = Number($modalTunnelDevis.data('isPro')) === 1;
    isCommand = $(event.currentTarget).is('#boutonCommande');

    const $quotationDynamiqueModal = $('#quotation-dynamique-modal');
    const $quotationBaseModal = $('#quotation-base-modal');

    updateFieldFromAnother($('#selectDeliveryPointEmotors'), $('#selectDeliveryPointEmotorsQuotation'));
    updateFieldFromAnother($('#deliveryAddressExpedicar'), $('#deliveryAddressExpedicarQuotation'));
    updateFieldFromAnother($('#deliveryZipCodeExpedicar'), $('#deliveryZipCodeExpedicarQuotation'));
    updateFieldFromAnother($('#deliveryCityExpedicar'), $('#deliveryCityExpedicarQuotation'));
    updateFieldFromAnother($('#deliveryCountryExpedicar'), $('#deliveryCountryExpedicarQuotation'));
    updateCheckboxFromAnother($('#expedicarWithHandoverService'), $('#expedicarWithHandoverServiceQuotation'));
    updateCheckboxFromAnother($('#expedicarWithExteriorWashing'), $('#expedicarWithExteriorWashingQuotation'));
    updateFieldFromAnother($('#selectDeliveryPointCarrier'), $('#selectDeliveryPointCarrierQuotation'));
    $('#priceJourneyQuotation').text($('#priceJourney').text());

    $('#priceJourneyQuotation').removeClass('hide');
    $('#errorExpedicarQuotation').addClass('hide');

    dataForQuotation = getDataForCreateQuotation();

    if (typeof dataForQuotation.error !== 'undefined') {
        toastr.options = {
            closeButton: true,
            positionClass: 'toast-bottom-right',
            showMethod: 'slideDown',
            hideMethod: 'slideUp',
            closeMethod: 'slideUp',
            timeOut: '8000',
            extendedTimeOut: '1500',
            tapToDismiss: false,
        };

        toastr.error(dataForQuotation.error);
    } else {
        $quotationDynamiqueModal.hide();
        $quotationBaseModal.show();

        if (isPro) {
            $('.tunnelDevisStep1, .footerTunnelDevisStep1').hide();
            $('.tunnelDevisStep0, .footerTunnelDevisStep0').hide();
            $('.tunnelDevisStep2, .footerTunnelDevisStep2').show();
        } else {
            $('.tunnelDevisStep1, .footerTunnelDevisStep1').hide();
            $('.tunnelDevisStep2, .footerTunnelDevisStep2').hide();
            $('.tunnelDevisStep0, .footerTunnelDevisStep0').show();
        }

        $('#myModalLabel').text((isCommand) ? 'Commander votre véhicule dès maintenant !' : 'Votre devis gratuit immédiatement !' );

        $modalTunnelDevis.modal();
        $('.nextStepTunnelDevisStep0').unbind().click(() => {
            $('.tunnelDevisStep0, .footerTunnelDevisStep0').hide();
            $('.tunnelDevisStep2, .footerTunnelDevisStep2').show();
            $('.prevStepTunnelDevisStep2').unbind().click(() => {
                $('.tunnelDevisStep2, .footerTunnelDevisStep2').hide();
                $('.tunnelDevisStep0, .footerTunnelDevisStep0').show();
                $('#quotation-base-modal').modal('handleUpdate');
            });
        });

        $('.nextStepTunnelDevisStep2')
            .unbind()
            .click(function (ev) {
                const onDataValidated = () => {
                    $(ev.currentTarget).hide();
                    $('.loaderPDF').removeClass('hide');
                    //  $modalTunnelDevis.modal('hide');

                    dataForQuotation = getCompleteDataForCreateQuotation();
                    dataForQuotation.isCommand = isCommand;
                    createQuotation(createQutotationAjaxURL, dataForQuotation, toastr, isCommand);
                };

                if (isExpedicar()) {
                    const elemAddress = $('#deliveryAddressExpedicarQuotation');
                    const elemZipCode = $('#deliveryZipCodeExpedicarQuotation');
                    const elemCity = $('#deliveryCityExpedicarQuotation');
                    const elemCountry = $('#deliveryCountryExpedicarQuotation');

                    elemAddress.val(elemAddress.val().trim());
                    elemZipCode.val(elemZipCode.val().trim());
                    elemCity.val(elemCity.val().trim());
                    elemCountry.val(elemCountry.val().trim());

                    const hasErrors = $('#formExpedicarParamsQuotation').validator('validate').has('.has-error').length > 0;

                    if (!hasErrors) {
                        onDataValidated();
                    }
                } else {
                    onDataValidated();
                }
            });
    }
});

/**
 * Met à jour un champ pour qu'il soit en concordance avec un autre
 *
 * @param $initialElement Champ d'origine
 * @param $elementToUpdate Champ à mettre à jour
 */
function updateFieldFromAnother($initialElement, $elementToUpdate) {
    if ($elementToUpdate.length > 0) {
        const customFormInstance = jcf.getInstance($elementToUpdate);

        $elementToUpdate.val($initialElement.val());
        if (typeof customFormInstance !== 'undefined') {
            customFormInstance.refresh();
        }
    }
}

/**
 * Met à jour un checkbox pour qu'il soit en concordance avec un autre
 *
 * @param $initialCheckbox Checkbox d'origine
 * @param $checkboxToUpdate Checkbox à mettre à jour
 */
function updateCheckboxFromAnother($initialCheckbox, $checkboxToUpdate) {
    if ($checkboxToUpdate.length > 0) {
        const isChecked = $initialCheckbox.is(':checked');
        const customFormInstance = jcf.getInstance($checkboxToUpdate);

        $checkboxToUpdate.prop('checked', isChecked);
        if (typeof customFormInstance !== 'undefined') {
            customFormInstance.refresh();
        }
    }
}

$('#modalTunnelDevis').on('hidden.bs.modal', function () {
    $('.tunnelDevisStep2, .headerTunnelDevisStep2, .footerTunnelDevisStep2').fadeOut();
    $('.tunnelDevisStep3, .headerTunnelDevisStep3, .footerTunnelDevisStep3').fadeOut();
    $('.tunnelDevisStep4, .headerTunnelDevisStep4, .footerTunnelDevisStep4').fadeOut();
    $('.tunnelDevisStep1, .headerTunnelDevisStep1, .footerTunnelDevisStep1').fadeIn();
});

$(document).on('click', '.callConnexionTunnelDevis', function () {
    var $modalFormulaireConnexion = $('#modalFormulaireConnexion');
    var $modalFormulaireInscription = $('#modalFormulaireInscription');
    $('.previousStepTunnelDevisStep1').attr('beforeState', 'modalFormulaireInscription');
    $modalFormulaireConnexion.show();
    $modalFormulaireInscription.hide();
});

$(document).on('click', '.previousStepTunnelDevisStep1', function (event) {
    var $modalTunneldDevis = $('#modalTunnelDevis');
    var $modalTunnelDevisDynamique = $('#modalTunnelDevisDynamique');
    var $this = $(event.currentTarget);
    var $modalFormulaireConnexion = $('#modalFormulaireConnexion');
    var $modalFormulaireInscription = $('#modalFormulaireInscription');

    if (typeof $this.attr('beforeState') !== 'undefined' && $this.attr('beforeState') !== '') {
        if ($this.attr('beforeState') === 'modalFormulaireConnexion') {
            $('.callConnexionTunnelDevis').click();
        } else {
            $('.previousStepTunnelDevisStep1').attr('beforeState', 'modalFormulaireConnexion');
            $modalFormulaireConnexion.hide();
            $modalFormulaireInscription.show();
        }
        $this.attr('beforeState', '');
    } else {
        $modalTunneldDevis.modal('hide');
        $modalTunnelDevisDynamique.modal('hide');
        if (isCommand) {
            $('#boutonCommande').click();
        } else {
            $('#boutonDevis').click();
        }
    }
});

// Affichage de la modal devis postal
$(document).on('click', '#getPostalQuotation', function () {
    var $choosePostalQuotationAddress = $('#choosePostalQuotationAddress');

    $('.modal').modal('hide');
    $choosePostalQuotationAddress.modal('show');
});

$('#checkEnvoiPostal').click(function (event) {
    if ($(event.currentTarget).is(':checked')) {
        $('#adressePostaleEnvoiDevis').show();
    } else {
        $('#adressePostaleEnvoiDevis').hide();
    }
});
$(document).ready(function () {
    let repurchaseForm = new RepurchaseForm('#withReprise form');
    repurchaseForm.on('success-save', () => {
        $('#withReprise').modal('hide');
        setToastr(toastr, 'La demande de reprise a bien été prise en compte.', 'success');
    });

    $('#withReprise').on('show.bs.modal', function () {
        $('#modal-document0').modal('hide');
    }).on('hide.bs.modal', function () {
        $('#modal-document0').modal('show');
    }).on('shown.bs.modal', function () {
        repurchaseForm.ready();
    });
});
